import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

export default function ConfirmDialog({ confirmDialog, setConfirmDialog, itemToDelete, setItemToDelete, deleteEintrag }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={confirmDialog}
      onClose={(e) => {
        e.stopPropagation();
        setConfirmDialog(false);
      }}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          background: (theme) =>
            `linear-gradient(
          180deg,
          ${theme.palette.error.main}12 0%,
          transparent 100%
        )`,
          pb: 2,
        }}
      >
        <WarningAmberOutlinedIcon
          color="error"
          sx={{
            fontSize: 28,
          }}
        />

        <Typography variant="h6" component="div" fontWeight={700}>
          {t("Meldung löschen")}
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 2,
        }}
      >
        <Typography variant="body1">{t("Möchten Sie die Meldung wirklich löschen?")}</Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 1.5,
            px: 1.5,
            py: 1,
            borderRadius: 2,
            bgcolor: "action.hover",
            fontWeight: 600,
          }}
        >
          "{itemToDelete?.betreff}"
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: "block",
            mt: 1.5,
          }}
        >
          {t("Diese Aktion ist endgültig!")}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          pt: 1,
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDialog(false);
            setItemToDelete(null);
          }}
          sx={{
            borderRadius: 2,
            textTransform: "none",
          }}
        >
          {t("Abbrechen")}
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDialog(false);
            deleteEintrag();
          }}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 700,
          }}
        >
          {t("Löschen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
